export default "__VITE_ASSET__CzqLu1i$__"